// import React, { useEffect, useCallback, useState } from "react"; // Added useState
// import Offcanvas from "react-bootstrap/Offcanvas";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import {
//   Box,
//   Grid,
//   Typography,
//   TextField,
//   Autocomplete,
//   Checkbox,
//   MenuItem,
//   Button, // Added Button
// } from "@mui/material";
// import {
//   PiUserLight,
//   PiMailboxLight,
//   PiChairLight,
//   PiAddressBookLight,
//   PiIdentificationCardLight,
//   PiMapPinSimpleAreaLight,
//   PiNewspaperClippingLight,
//   PiBuildingLight,
// } from "react-icons/pi";
// import { CiMobile3 } from "react-icons/ci";
// import { RxCross2 } from "react-icons/rx";
// import styles from "./Candidate.module.css";
// import { useDispatch, useSelector } from "react-redux";
// import { createCandidate } from "../../redux/hotlist/hotListSlice";
// import { allSkill } from "../../redux/common/skillSlice";
// import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
// import { allLocation } from "../../redux/common/locationSlice";
// import { customTextColor } from "../../utils/const";
// import { createSelector } from "reselect";

// // Base selectors
// const selectLocation = (state) => state.location;
// const selectSkill = (state) => state.skill;
// const selectWorkAutho = (state) => state.workautho;

// // Memoized selectors
// const selectLocationsData = createSelector(
//   [selectLocation],
//   (location) => location.data?.locations || []
// );

// const selectSkillData = createSelector(
//   [selectSkill],
//   (skill) => skill.data?.locations || [] // Adjust to skill.data?.skills if needed
// );

// const selectWorkAuthoData = createSelector(
//   [selectWorkAutho],
//   (workautho) => workautho.data?.work_authorization_data || []
// );

// // Field styling
// const fieldStyle = {
//   width: "100%",
//   "& .MuiInputBase-root": {
//     paddingLeft: "30px",
//   },
//   "& .MuiInputLabel-root": {
//     left: "35px",
//     fontSize: "14px",
//   },
//   "& .MuiInputBase-input": {
//     paddingBottom: "7px",
//   },
//   "& .MuiInputLabel-shrink": {
//     left: "35px",
//     fontSize: "14px",
//   },
//   padding: "7px",
//   marginLeft: "5px",
// };

// // Willing to relocate options
// const relocateOptions = [
//   { id: "yes", value: true, name: "Yes" },
//   { id: "no", value: false, name: "No" },
// ];

// const CreateHotListDraw = ({
//   show,
//   handleClose,
//   hotListName,
//   selectedCandidate,
//   hotListId,
// }) => {
//   const dispatch = useDispatch();
//   const locationsData = useSelector(selectLocationsData);
//   const skillData = useSelector(selectSkillData);
//   const workauthoData = useSelector(selectWorkAuthoData);
//   const [isResumeRemoved, setIsResumeRemoved] = useState(false); // State to track resume removal

//   // Fetch necessary data when the component mounts
//   useEffect(() => {
//     if (!locationsData.length) dispatch(allLocation());
//     if (!workauthoData.length) dispatch(allWorkAuthorization());
//     if (!skillData.length) dispatch(allSkill());
//   }, [dispatch, locationsData.length, workauthoData.length, skillData.length]);

//   const initialFormValues = {
//     full_name: "",
//     current_job_title: "",
//     total_experience: "",
//     mobile_no: "",
//     email: "",
//     work_authorization: "",
//     current_location: "",
//     prefer_location: [],
//     primary_skills: [],
//     secondary_skills: [],
//     resume_profile_id: "", // Changed from resume to resume_profile_id
//     willing_to_relocate: "",
//     rate: "",
//     last_project: "",
//   };

//   // Initialize formik with selectedCandidate data if available
//   const formik = useFormik({
//     initialValues: selectedCandidate
//       ? {
//           full_name: selectedCandidate.full_name || "",
//           current_job_title: selectedCandidate.current_job_title || "",
//           total_experience: selectedCandidate.total_experience || "",
//           mobile_no: selectedCandidate.mobile_no || "",
//           email: selectedCandidate.email || "",
//           work_authorization: selectedCandidate.work_authorization || "",
//           current_location: selectedCandidate.current_location || "",
//           prefer_location: selectedCandidate.prefer_location || [],
//           primary_skills: selectedCandidate.skills || [],
//           secondary_skills: selectedCandidate.secondary_skills || [],
//           resume_profile_id: selectedCandidate.id || "", // Set to selectedCandidate.id
//           willing_to_relocate: selectedCandidate.willing_to_relocate
//             ? "yes"
//             : "no",
//           rate: selectedCandidate.rate || "",
//           last_project: selectedCandidate.last_project || "",
//         }
//       : initialFormValues,
//     validationSchema: Yup.object({
//       full_name: Yup.string().required("Full Name is required"),
//       current_job_title: Yup.string().required("Job Title is required"),
//       total_experience: Yup.string().required("Experience is required"),
//       mobile_no: Yup.string()
//         .matches(
//           /^[\d\s.\-()+]*$/,
//           "Mobile Number must be a valid phone number"
//         )
//         .required("Mobile Number is required"),
//       email: Yup.string()
//         .email("Invalid email address")
//         .required("Email is required"),
//       work_authorization: Yup.string().required(
//         "Work Authorization is required"
//       ),
//       current_location: Yup.string().required("Current Location is required"),
//       prefer_location: Yup.array().when("willing_to_relocate", {
//         is: (value) => value === "yes",
//         then: (schema) =>
//           schema
//             .of(Yup.number())
//             .min(1, "Prefer Location is required")
//             .required("Prefer Location is required"),
//         otherwise: (schema) => schema.of(Yup.number()),
//       }),
//       resume_profile_id: Yup.string().when("isResumeRemoved", {
//         is: false,
//         then: (schema) => schema.required("Resume is required"),
//         otherwise: (schema) => schema,
//       }),
//       willing_to_relocate: Yup.string()
//         .oneOf(["yes", "no"], "Please select Yes or No")
//         .required("Willing to Relocate is required"),
//       rate: Yup.number()
//         .required("Rate is required")
//         .integer("Rate must be an integer")
//         .min(1, "Rate must be at least 1"),
//       primary_skills: Yup.array()
//         .of(Yup.number())
//         .min(1, "At least one Primary Skill is required")
//         .required("Primary Skill is required"),
//       last_project: Yup.string().required("Current Company is required"),
//     }),
//     onSubmit: async (values, { resetForm }) => {
//       try {
//         const submitValues = {
//           ...values,
//           willing_to_relocate: values.willing_to_relocate === "yes",
//           hot_list: hotListId,
//         };

//         // Remove resume_profile_id from submission if resume is removed
//         if (isResumeRemoved) {
//           delete submitValues.resume_profile_id;
//         }


//         const candidateResponse = await dispatch(
//           createCandidate(submitValues)
//         ).unwrap();

//         if (candidateResponse) {
//           resetForm({ values: initialFormValues });
//           setIsResumeRemoved(false); // Reset the resume removal state
//           handleClose();
//         }
//       } catch (error) {
//         console.error("Error adding candidate to hotlist:", error);
//       }
//     },
//   });

//   // Reset form when drawer is closed or selectedCandidate changes
//   useEffect(() => {
//     if (!show) {
//       formik.resetForm({ values: initialFormValues });
//       setIsResumeRemoved(false); // Reset the resume removal state
//     } else if (selectedCandidate) {
//       formik.setValues({
//         full_name: selectedCandidate.full_name || "",
//         current_job_title: selectedCandidate.current_job_title || "",
//         total_experience: selectedCandidate.total_experience || "",
//         mobile_no: selectedCandidate.mobile_no || "",
//         email: selectedCandidate.email || "",
//         work_authorization: selectedCandidate.work_authorization || "",
//         current_location: selectedCandidate.current_location || "",
//         prefer_location: selectedCandidate.prefer_location || [],
//         primary_skills: selectedCandidate.skills || [],
//         secondary_skills: selectedCandidate.secondary_skills || [],
//         resume_profile_id: selectedCandidate.id || "", // Set to selectedCandidate.id
//         willing_to_relocate: selectedCandidate.willing_to_relocate
//           ? "yes"
//           : "no",
//         rate: selectedCandidate.rate || "",
//         last_project: selectedCandidate.last_project || "",
//       });
//       setIsResumeRemoved(false); // Reset the resume removal state
//     }
//   }, [show, selectedCandidate]);

//   const handleMobileNoChange = (e) => {
//     const value = e.target.value;
//     if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
//       formik.setFieldValue("mobile_no", value);
//     }
//   };

//   const handleRateChange = (e) => {
//     const value = e.target.value;
//     const numericValue = value.replace(/[^0-9]/g, "");
//     if (numericValue === "" || !isNaN(parseInt(numericValue))) {
//       formik.setFieldValue("rate", numericValue ? parseInt(numericValue) : "");
//     }
//   };

//   const handleRemoveResume = () => {
//     setIsResumeRemoved(true);
//     formik.setFieldValue("resume_profile_id", ""); // Clear the resume_profile_id field
//   };

//   const formatRateDisplay = (value) => {
//     return value ? `$${value} hourly` : "";
//   };

//   return (
//     <Offcanvas
//       show={show}
//       onHide={handleClose}
//       placement="end"
//       scroll={true}
//       backdrop={false}
//       style={{
//         border: "none",
//         marginTop: "65px",
//         width: "60%",
//         boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
//         <Box sx={{ padding: "10px 10px" }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "0px 10px",
//             }}
//           >
//             <Typography style={{ color: customTextColor, fontWeight: "bold" }}>
//               Add to Hotlist | {hotListName}
//             </Typography>
//             <RxCross2
//               style={{
//                 fontSize: "15px",
//                 cursor: "pointer",
//                 color: customTextColor,
//               }}
//               onClick={handleClose}
//             />
//           </Box>
//           <Box
//             className={styles.upload_resume_section}
//             sx={{
//               padding: "5px 15px",
//               margin: "5px 10px",
//               borderRadius: "3px",
//               bgcolor: "#f5f5f5",
//               mt: 1,
//               mb: 2,
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "flex-end",
//             }}
//           >
//             <Box
//               style={{ color: customTextColor }}
//               sx={{
//                 marginTop: "10px",
//               }}
//             >
//               <Typography
//                 sx={{
//                   marginBottom: "2px !important",
//                   fontSize: "20px !important",
//                 }}
//               >
//                 Unlimited Hotlist – Not Be Limit
//               </Typography>
//               <Typography>
//                 Boost highest possibility reaching to recruiters by filling
//                 below details
//               </Typography>
//             </Box>
//             <Box sx={{ mb: 1 }}>
//               {/* Add Remove Resume Button */}
//               {formik.values.resume_profile_id && !isResumeRemoved && (
//                 <button onClick={handleRemoveResume}>Remove Resume</button>
//               )}
//               {isResumeRemoved && (
//                 <Typography sx={{ color: "red", fontSize: "14px" }}>
//                   Resume Removed
//                 </Typography>
//               )}
//             </Box>
//           </Box>

//           <form onSubmit={formik.handleSubmit}>
//             <Grid container className={styles.candidate_field_section}>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 5px 0 5px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       formik.touched.full_name && formik.errors.full_name
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <PiUserLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="full_name"
//                   label="Candidate Name"
//                   variant="standard"
//                   name="full_name"
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.full_name}
//                   sx={fieldStyle}
//                 />
//                 {formik.touched.full_name && formik.errors.full_name && (
//                   <div className={styles.error}>{formik.errors.full_name}</div>
//                 )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       formik.touched.mobile_no && formik.errors.mobile_no
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <CiMobile3 style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="mobile_no"
//                   label="Contact No"
//                   variant="standard"
//                   type="text"
//                   name="mobile_no"
//                   onChange={handleMobileNoChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.mobile_no}
//                   sx={fieldStyle}
//                 />
//                 {formik.touched.mobile_no && formik.errors.mobile_no && (
//                   <div className={styles.error}>{formik.errors.mobile_no}</div>
//                 )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       (formik.touched.current_job_title &&
//                         formik.errors.current_job_title) ||
//                       (formik.touched.email && formik.errors.email)
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <PiMailboxLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="email"
//                   label="E-Mail ID"
//                   variant="standard"
//                   type="text"
//                   name="email"
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.email}
//                   sx={fieldStyle}
//                 />
//                 {formik.touched.email && formik.errors.email && (
//                   <div className={styles.error}>{formik.errors.email}</div>
//                 )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       (formik.touched.current_job_title &&
//                         formik.errors.current_job_title) ||
//                       (formik.touched.email && formik.errors.email)
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <PiChairLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="current_job_title"
//                   label="Current Job Profile"
//                   variant="standard"
//                   type="text"
//                   name="current_job_title"
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.current_job_title}
//                   sx={fieldStyle}
//                 />
//                 {formik.touched.current_job_title &&
//                   formik.errors.current_job_title && (
//                     <div className={styles.error}>
//                       {formik.errors.current_job_title}
//                     </div>
//                   )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       (formik.touched.last_project &&
//                         formik.errors.last_project) ||
//                       (formik.touched.total_experience &&
//                         formik.errors.total_experience)
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <PiBuildingLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="last_project"
//                   label="Current Company"
//                   variant="standard"
//                   type="text"
//                   name="last_project"
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.last_project}
//                   sx={fieldStyle}
//                 />
//                 {formik.touched.last_project && formik.errors.last_project && (
//                   <div className={styles.error}>
//                     {formik.errors.last_project}
//                   </div>
//                 )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       (formik.touched.work_authorization &&
//                         formik.errors.work_authorization) ||
//                       (formik.touched.total_experience &&
//                         formik.errors.total_experience)
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <PiAddressBookLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="total_experience"
//                   label="Total Experience"
//                   variant="standard"
//                   type="text"
//                   name="total_experience"
//                   onChange={(e) => {
//                     const rawValue = e.target.value.replace(/[^0-9.]/g, "");
//                     formik.setFieldValue("total_experience", rawValue);
//                   }}
//                   onBlur={formik.handleBlur}
//                   value={
//                     formik.values.total_experience
//                       ? `${formik.values.total_experience} ${
//                           formik.values.total_experience > 1 ? "Years" : "Year"
//                         }`
//                       : ""
//                   }
//                   sx={fieldStyle}
//                 />
//                 {formik.touched.total_experience &&
//                   formik.errors.total_experience && (
//                     <div className={styles.error}>
//                       {formik.errors.total_experience}
//                     </div>
//                   )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       (formik.touched.work_authorization &&
//                         formik.errors.work_authorization) ||
//                       (formik.touched.total_experience &&
//                         formik.errors.total_experience)
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <PiIdentificationCardLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="work_authorization"
//                   select
//                   label="Work Authorization"
//                   variant="standard"
//                   name="work_authorization"
//                   value={formik.values.work_authorization}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   sx={fieldStyle}
//                 >
//                   {workauthoData.map((option) => (
//                     <MenuItem key={option.id} value={option.id}>
//                       {option.name}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//                 {formik.touched.work_authorization &&
//                   formik.errors.work_authorization && (
//                     <div className={styles.error}>
//                       {formik.errors.work_authorization}
//                     </div>
//                   )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       (formik.touched.willing_to_relocate &&
//                         formik.errors.willing_to_relocate) ||
//                       (formik.touched.current_location &&
//                         formik.errors.current_location)
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="current_location"
//                   select
//                   label="Current Location"
//                   variant="standard"
//                   name="current_location"
//                   value={formik.values.current_location}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   sx={fieldStyle}
//                 >
//                   {locationsData.map((option) => (
//                     <MenuItem key={option.id} value={option.id}>
//                       {option.name}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//                 {formik.touched.current_location &&
//                   formik.errors.current_location && (
//                     <div className={styles.error}>
//                       {formik.errors.current_location}
//                     </div>
//                   )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       (formik.touched.willing_to_relocate &&
//                         formik.errors.willing_to_relocate) ||
//                       (formik.touched.current_location &&
//                         formik.errors.current_location)
//                         ? "45%"
//                         : "62%",
//                   }}
//                 >
//                   <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="willing_to_relocate"
//                   select
//                   label="Willing to Relocate"
//                   variant="standard"
//                   name="willing_to_relocate"
//                   value={formik.values.willing_to_relocate}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   sx={fieldStyle}
//                 >
//                   {relocateOptions.map((option) => (
//                     <MenuItem key={option.id} value={option.id}>
//                       {option.name}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//                 {formik.touched.willing_to_relocate &&
//                   formik.errors.willing_to_relocate && (
//                     <div className={styles.error}>
//                       {formik.errors.willing_to_relocate}
//                     </div>
//                   )}
//               </Grid>
//               {formik.values.willing_to_relocate === "yes" && (
//                 <Grid
//                   item
//                   xs={12}
//                   sm={12}
//                   md={6}
//                   lg={6}
//                   sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//                 >
//                   <Box
//                     className={styles.icon_style}
//                     style={{
//                       top:
//                         (formik.touched.prefer_location &&
//                           formik.errors.prefer_location) ||
//                         (formik.touched.rate && formik.errors.rate)
//                           ? "45%"
//                           : "62%",
//                     }}
//                   >
//                     <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
//                   </Box>
//                   <Autocomplete
//                     multiple
//                     id="prefer_location-autocomplete"
//                     options={locationsData}
//                     disableCloseOnSelect
//                     value={locationsData.filter((location) =>
//                       formik.values.prefer_location.includes(location.id)
//                     )}
//                     onChange={(event, value) => {
//                       const selectedValues = value.map(
//                         (location) => location.id
//                       );
//                       formik.setFieldValue("prefer_location", selectedValues);
//                     }}
//                     onBlur={formik.handleBlur}
//                     getOptionLabel={(option) => option.name}
//                     renderOption={(props, option, { selected }) => (
//                       <MenuItem {...props}>
//                         <Checkbox
//                           checked={selected}
//                           sx={{ marginRight: 0, marginLeft: 0 }}
//                         />
//                         <span>{option.name}</span>
//                       </MenuItem>
//                     )}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Preferred Location"
//                         variant="standard"
//                         name="prefer_location"
//                         sx={fieldStyle}
//                       />
//                     )}
//                     sx={{ backgroundColor: "#fff", width: "100%" }}
//                   />
//                   {formik.touched.prefer_location &&
//                     formik.errors.prefer_location && (
//                       <div className={styles.error}>
//                         {formik.errors.prefer_location}
//                       </div>
//                     )}
//                 </Grid>
//               )}
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={6}
//                 lg={6}
//                 sx={{ padding: "5px 10px 0 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       formik.touched.rate && formik.errors.rate ? "45%" : "62%",
//                   }}
//                 >
//                   <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <TextField
//                   id="rate"
//                   label="Hourly Rate"
//                   variant="standard"
//                   name="rate"
//                   onChange={handleRateChange}
//                   onBlur={formik.handleBlur}
//                   value={formatRateDisplay(formik.values.rate)}
//                   sx={fieldStyle}
//                 />
//                 {formik.touched.rate && formik.errors.rate && (
//                   <div className={styles.error}>{formik.errors.rate}</div>
//                 )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={12}
//                 lg={12}
//                 sx={{ padding: "5px 10px 10px 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       formik.touched.primary_skills &&
//                       formik.errors.primary_skills
//                         ? "40%"
//                         : "60%",
//                   }}
//                 >
//                   <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <Autocomplete
//                   multiple
//                   id="primary-skills-autocomplete"
//                   options={skillData}
//                   disableCloseOnSelect
//                   value={skillData.filter((skill) =>
//                     formik.values.primary_skills.includes(skill.id)
//                   )}
//                   onChange={(event, value) => {
//                     const selectedValues = value.map((skill) => skill.id);
//                     formik.setFieldValue("primary_skills", selectedValues);
//                   }}
//                   onBlur={formik.handleBlur}
//                   getOptionLabel={(option) => option.name}
//                   renderOption={(props, option, { selected }) => (
//                     <MenuItem {...props}>
//                       <Checkbox
//                         checked={selected}
//                         sx={{ marginRight: 0, marginLeft: 0 }}
//                       />
//                       <span>{option.name}</span>
//                     </MenuItem>
//                   )}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label="Primary Skills"
//                       variant="standard"
//                       name="primary_skills"
//                       sx={fieldStyle}
//                     />
//                   )}
//                   sx={{ backgroundColor: "#fff", width: "100%" }}
//                 />
//                 {formik.touched.primary_skills &&
//                   formik.errors.primary_skills && (
//                     <div className={styles.error}>
//                       {formik.errors.primary_skills}
//                     </div>
//                   )}
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sm={12}
//                 md={12}
//                 lg={12}
//                 sx={{ padding: "5px 10px 10px 10px", position: "relative" }}
//               >
//                 <Box
//                   className={styles.icon_style}
//                   style={{
//                     top:
//                       formik.touched.secondary_skills &&
//                       formik.errors.secondary_skills
//                         ? "40%"
//                         : "60%",
//                   }}
//                 >
//                   <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
//                 </Box>
//                 <Autocomplete
//                   multiple
//                   id="secondary-skills-autocomplete"
//                   options={skillData}
//                   disableCloseOnSelect
//                   value={skillData.filter((skill) =>
//                     formik.values.secondary_skills.includes(skill.id)
//                   )}
//                   onChange={(event, value) => {
//                     const selectedValues = value.map((skill) => skill.id);
//                     formik.setFieldValue("secondary_skills", selectedValues);
//                   }}
//                   onBlur={formik.handleBlur}
//                   getOptionLabel={(option) => option.name}
//                   renderOption={(props, option, { selected }) => (
//                     <MenuItem {...props}>
//                       <Checkbox
//                         checked={selected}
//                         sx={{ marginRight: 0, marginLeft: 0 }}
//                       />
//                       <span>{option.name}</span>
//                     </MenuItem>
//                   )}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label="Secondary Skills"
//                       variant="standard"
//                       name="secondary_skills"
//                       sx={fieldStyle}
//                     />
//                   )}
//                   sx={{ backgroundColor: "#fff", width: "100%" }}
//                 />
//               </Grid>
//             </Grid>
//             <Box className={styles.add_consultant_btns}>
//               <button type="submit" disabled={formik.isSubmitting}>
//                 {formik.isSubmitting ? "Adding..." : "Add to Hotlist"}
//               </button>
//             </Box>
//           </form>
//         </Box>
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

// export default CreateHotListDraw;

import React, { useEffect, useCallback, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Autocomplete,
  Checkbox,
  MenuItem,
  Button,
} from "@mui/material";
import {
  PiUserLight,
  PiMailboxLight,
  PiChairLight,
  PiAddressBookLight,
  PiIdentificationCardLight,
  PiMapPinSimpleAreaLight,
  PiNewspaperClippingLight,
  PiBuildingLight,
} from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { RxCross2 } from "react-icons/rx";
import styles from "./Candidate.module.css";
import { useDispatch, useSelector } from "react-redux";
import { createCandidate } from "../../redux/hotlist/hotListSlice";
import { allSkill } from "../../redux/common/skillSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../redux/common/locationSlice";
import { customTextColor } from "../../utils/const";
import { updateCandidate } from "../../redux/hotlist/hotListSlice";
import { createSelector } from "reselect";

// Base selectors
const selectLocation = (state) => state.location;
const selectSkill = (state) => state.skill;
const selectWorkAutho = (state) => state.workautho;

// Memoized selectors
const selectLocationsData = createSelector(
  [selectLocation],
  (location) => location.data?.locations || []
);

const selectSkillData = createSelector(
  [selectSkill],
  (skill) => skill.data?.locations || [] // Adjust to skill.data?.skills if needed
);

const selectWorkAuthoData = createSelector(
  [selectWorkAutho],
  (workautho) => workautho.data?.work_authorization_data || []
);

// Field styling
const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px",
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px",
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px",
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px",
  },
  padding: "7px",
  marginLeft: "5px",
};

// Willing to relocate options
const relocateOptions = [
  { id: "yes", value: true, name: "Yes" },
  { id: "no", value: false, name: "No" },
];

const CreateHotListDraw = ({
  show,
  handleClose,
  hotListName,
  selectedCandidate,
  hotListId,
  isEdit,
}) => {
  const dispatch = useDispatch();
  const locationsData = useSelector(selectLocationsData);
  const skillData = useSelector(selectSkillData);
  const workauthoData = useSelector(selectWorkAuthoData);

  // Fetch necessary data when the component mounts
  useEffect(() => {
    if (!locationsData.length) dispatch(allLocation());
    if (!workauthoData.length) dispatch(allWorkAuthorization());
    if (!skillData.length) dispatch(allSkill());
  }, [dispatch, locationsData.length, workauthoData.length, skillData.length]);

  const initialFormValues = {
    full_name: "",
    current_job_title: "",
    total_experience: "",
    mobile_no: "",
    email: "",
    work_authorization: "",
    current_location: "",
    prefer_location: [],
    primary_skills: [],
    secondary_skills: [],
    resume_profile_id: "",
    resume: "", // Initialize as empty string (URL)
    willing_to_relocate: "",
    rate: "",
    last_project: "",
  };

  // Initialize formik with selectedCandidate data if available
  const formik = useFormik({
    initialValues: selectedCandidate
      ? {
          full_name: selectedCandidate.full_name || "",
          current_job_title: selectedCandidate.current_job_title || "",
          total_experience: selectedCandidate.total_experience || "",
          mobile_no: selectedCandidate.mobile_no || "",
          email: selectedCandidate.email || "",
          work_authorization: selectedCandidate.work_authorization || "",
          current_location: selectedCandidate.current_location || "",
          prefer_location: selectedCandidate.prefer_location || [],
          primary_skills:
            selectedCandidate.skills || selectedCandidate.primary_skills || [],
          secondary_skills: selectedCandidate.secondary_skills || [],
          resume_profile_id: selectedCandidate.id || "",
          resume: selectedCandidate.resume || "", // Set to selectedCandidate.resume (URL) or empty string
          willing_to_relocate: selectedCandidate.willing_to_relocate
            ? "yes"
            : "no",
          rate: selectedCandidate.rate || "",
          last_project:
            selectedCandidate.current_company ||
            selectedCandidate.last_project ||
            "",
        }
      : initialFormValues,
    validationSchema: Yup.object({
      full_name: Yup.string().required("Full Name is required"),
      current_job_title: Yup.string().required("Job Title is required"),
      total_experience: Yup.string().required("Experience is required"),
      mobile_no: Yup.string()
        .matches(
          /^[\d\s.\-()+]*$/,
          "Mobile Number must be a valid phone number"
        )
        .required("Mobile Number is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      work_authorization: Yup.string().required(
        "Work Authorization is required"
      ),
      current_location: Yup.string().required("Current Location is required"),
      prefer_location: Yup.array().when("willing_to_relocate", {
        is: (value) => value === "yes",
        then: (schema) =>
          schema
            .of(Yup.number())
            .min(1, "Prefer Location is required")
            .required("Prefer Location is required"),
        otherwise: (schema) => schema.of(Yup.number()),
      }),
      resume_profile_id: Yup.string().required("Resume Profile ID is required"),
      willing_to_relocate: Yup.string()
        .oneOf(["yes", "no"], "Please select Yes or No")
        .required("Willing to Relocate is required"),
      rate: Yup.number()
        .required("Rate is required")
        .integer("Rate must be an integer")
        .min(1, "Rate must be at least 1"),
      primary_skills: Yup.array()
        .of(Yup.number())
        .min(1, "At least one Primary Skill is required")
        .required("Primary Skill is required"),
      last_project: Yup.string().required("Current Company is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        // Transform willing_to_relocate to boolean
        const isWillingToRelocate = values.willing_to_relocate === "yes";
        const isResume = values.resume;
        // Conditionally include prefer_location based on willing_to_relocate
        const submitValues = {
          ...values,
          willing_to_relocate: isWillingToRelocate,
          hot_list: hotListId,
          ...(isWillingToRelocate
            ? { prefer_location: values.prefer_location }
            : {}),
        };

        // Remove prefer_location if willing_to_relocate is false
        if (!isWillingToRelocate) {
          delete submitValues.prefer_location;
        }

        if (!isResume) {
          delete submitValues.resume;
        }


        const candidateResponse = await dispatch(
          isEdit
            ? updateCandidate({
                candidate_id: selectedCandidate.id,
                data: submitValues,
              })
            : createCandidate(submitValues)
        ).unwrap();

        if (candidateResponse) {
          resetForm({ values: initialFormValues });
          handleClose();
        }
      } catch (error) {
        console.error("Error adding candidate to hotlist:", error);
      }
    },
  });

  // Reset form when drawer is closed or selectedCandidate changes
  useEffect(() => {
    if (!show) {
      formik.resetForm({ values: initialFormValues });
    } else if (selectedCandidate) {
      formik.setValues({
        full_name: selectedCandidate.full_name || "",
        current_job_title: selectedCandidate.current_job_title || "",
        total_experience: selectedCandidate.total_experience || "",
        mobile_no: selectedCandidate.mobile_no || "",
        email: selectedCandidate.email || "",
        work_authorization: selectedCandidate.work_authorization || "",
        current_location: selectedCandidate.current_location || "",
        prefer_location: selectedCandidate.prefer_location || [],
        primary_skills:
          selectedCandidate.skills || selectedCandidate.primary_skills || [],
        secondary_skills: selectedCandidate.secondary_skills || [],
        resume_profile_id: selectedCandidate.id || "",
        resume: selectedCandidate.resume || "", // Set to selectedCandidate.resume (URL) or empty string
        willing_to_relocate: selectedCandidate.willing_to_relocate
          ? "yes"
          : "no",
        rate: selectedCandidate.rate || "",
        last_project:
          selectedCandidate.current_company ||
          selectedCandidate.last_project ||
          "",
      });
    }
  }, [show, selectedCandidate]);

  const handleMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
      formik.setFieldValue("mobile_no", value);
    }
  };

  const handleRateChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9]/g, "");
    if (numericValue === "" || !isNaN(parseInt(numericValue))) {
      formik.setFieldValue("rate", numericValue ? parseInt(numericValue) : "");
    }
  };

  const handleRemoveResume = () => {
    formik.setFieldValue("resume", ""); // Set to empty string when removing resume
  };

  const formatRateDisplay = (value) => {
    return value ? `$${value} hourly` : "";
  };

  // Display selectedCandidate.resume as-is
  const getResumeDisplay = () => {
    if (!selectedCandidate?.resume) return "No Resume";
    return selectedCandidate.resume; // Use as-is
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "60%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px 10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 10px",
            }}
          >
            <Typography style={{ color: customTextColor, fontWeight: "bold" }}>
              {isEdit ? "Edit Hotlist" : "Add to Hotlist"} | {hotListName}
            </Typography>
            <RxCross2
              style={{
                fontSize: "15px",
                cursor: "pointer",
                color: customTextColor,
              }}
              onClick={handleClose}
            />
          </Box>
          <Box
            className={styles.upload_resume_section}
            sx={{
              padding: "5px 15px",
              margin: "5px 10px",
              borderRadius: "3px",
              bgcolor: "#f5f5f5",
              mt: 1,
              mb: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <Box
              style={{ color: customTextColor }}
              sx={{
                marginTop: "10px",
              }}
            >
              <Typography
                sx={{
                  marginBottom: "2px !important",
                  fontSize: "20px !important",
                }}
              >
                Unlimited Hotlist – Not Be Limit
              </Typography>
              <Typography>
                Boost highest possibility reaching to recruiters by filling
                below details
              </Typography>
            </Box>
            <Box sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
              {formik.values.resume_profile_id && formik.values.resume && (
                <>
                  <button onClick={handleRemoveResume}>Remove Resume</button>
                </>
              )}
              {!formik.values.resume && (
                <Typography sx={{ color: "red", fontSize: "14px" }}>
                  Resume Removed
                </Typography>
              )}
            </Box>
          </Box>

          <form onSubmit={formik.handleSubmit}>
            <Grid container className={styles.candidate_field_section}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 5px 0 5px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      formik.touched.full_name && formik.errors.full_name
                        ? "45%"
                        : "62%",
                  }}
                >
                  <PiUserLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="full_name"
                  label="Candidate Name"
                  variant="standard"
                  name="full_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.full_name}
                  sx={fieldStyle}
                />
                {formik.touched.full_name && formik.errors.full_name && (
                  <div className={styles.error}>{formik.errors.full_name}</div>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      formik.touched.mobile_no && formik.errors.mobile_no
                        ? "45%"
                        : "62%",
                  }}
                >
                  <CiMobile3 style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="mobile_no"
                  label="Contact No"
                  variant="standard"
                  type="text"
                  name="mobile_no"
                  onChange={handleMobileNoChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mobile_no}
                  sx={fieldStyle}
                />
                {formik.touched.mobile_no && formik.errors.mobile_no && (
                  <div className={styles.error}>{formik.errors.mobile_no}</div>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      (formik.touched.current_job_title &&
                        formik.errors.current_job_title) ||
                      (formik.touched.email && formik.errors.email)
                        ? "45%"
                        : "62%",
                  }}
                >
                  <PiMailboxLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="email"
                  label="E-Mail ID"
                  variant="standard"
                  type="text"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  sx={fieldStyle}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className={styles.error}>{formik.errors.email}</div>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      (formik.touched.current_job_title &&
                        formik.errors.current_job_title) ||
                      (formik.touched.email && formik.errors.email)
                        ? "45%"
                        : "62%",
                  }}
                >
                  <PiChairLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="current_job_title"
                  label="Current Job Profile"
                  variant="standard"
                  type="text"
                  name="current_job_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.current_job_title}
                  sx={fieldStyle}
                />
                {formik.touched.current_job_title &&
                  formik.errors.current_job_title && (
                    <div className={styles.error}>
                      {formik.errors.current_job_title}
                    </div>
                  )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      (formik.touched.last_project &&
                        formik.errors.last_project) ||
                      (formik.touched.total_experience &&
                        formik.errors.total_experience)
                        ? "45%"
                        : "62%",
                  }}
                >
                  <PiBuildingLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="last_project"
                  label="Current Company"
                  variant="standard"
                  type="text"
                  name="last_project"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.last_project}
                  sx={fieldStyle}
                />
                {formik.touched.last_project && formik.errors.last_project && (
                  <div className={styles.error}>
                    {formik.errors.last_project}
                  </div>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      (formik.touched.work_authorization &&
                        formik.errors.work_authorization) ||
                      (formik.touched.total_experience &&
                        formik.errors.total_experience)
                        ? "45%"
                        : "62%",
                  }}
                >
                  <PiAddressBookLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="total_experience"
                  label="Total Experience"
                  variant="standard"
                  type="text"
                  name="total_experience"
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                    formik.setFieldValue("total_experience", rawValue);
                  }}
                  onBlur={formik.handleBlur}
                  value={
                    formik.values.total_experience
                      ? `${formik.values.total_experience} ${
                          formik.values.total_experience > 1 ? "Years" : "Year"
                        }`
                      : ""
                  }
                  sx={fieldStyle}
                />
                {formik.touched.total_experience &&
                  formik.errors.total_experience && (
                    <div className={styles.error}>
                      {formik.errors.total_experience}
                    </div>
                  )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      (formik.touched.work_authorization &&
                        formik.errors.work_authorization) ||
                      (formik.touched.total_experience &&
                        formik.errors.total_experience)
                        ? "45%"
                        : "62%",
                  }}
                >
                  <PiIdentificationCardLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="work_authorization"
                  select
                  label="Work Authorization"
                  variant="standard"
                  name="work_authorization"
                  value={formik.values.work_authorization}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  sx={fieldStyle}
                >
                  {workauthoData.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.work_authorization &&
                  formik.errors.work_authorization && (
                    <div className={styles.error}>
                      {formik.errors.work_authorization}
                    </div>
                  )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      (formik.touched.willing_to_relocate &&
                        formik.errors.willing_to_relocate) ||
                      (formik.touched.current_location &&
                        formik.errors.current_location)
                        ? "45%"
                        : "62%",
                  }}
                >
                  <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="current_location"
                  select
                  label="Current Location"
                  variant="standard"
                  name="current_location"
                  value={formik.values.current_location}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  sx={fieldStyle}
                >
                  {locationsData.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.current_location &&
                  formik.errors.current_location && (
                    <div className={styles.error}>
                      {formik.errors.current_location}
                    </div>
                  )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      (formik.touched.willing_to_relocate &&
                        formik.errors.willing_to_relocate) ||
                      (formik.touched.current_location &&
                        formik.errors.current_location)
                        ? "45%"
                        : "62%",
                  }}
                >
                  <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="willing_to_relocate"
                  select
                  label="Willing to Relocate"
                  variant="standard"
                  name="willing_to_relocate"
                  value={formik.values.willing_to_relocate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  sx={fieldStyle}
                >
                  {relocateOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.willing_to_relocate &&
                  formik.errors.willing_to_relocate && (
                    <div className={styles.error}>
                      {formik.errors.willing_to_relocate}
                    </div>
                  )}
              </Grid>
              {formik.values.willing_to_relocate === "yes" && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                >
                  <Box
                    className={styles.icon_style}
                    style={{
                      top:
                        (formik.touched.prefer_location &&
                          formik.errors.prefer_location) ||
                        (formik.touched.rate && formik.errors.rate)
                          ? "45%"
                          : "62%",
                    }}
                  >
                    <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
                  </Box>
                  <Autocomplete
                    multiple
                    id="prefer_location-autocomplete"
                    options={locationsData}
                    disableCloseOnSelect
                    value={locationsData.filter((location) =>
                      formik.values.prefer_location.includes(location.id)
                    )}
                    onChange={(event, value) => {
                      const selectedValues = value.map(
                        (location) => location.id
                      );
                      formik.setFieldValue("prefer_location", selectedValues);
                    }}
                    onBlur={formik.handleBlur}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 0, marginLeft: 0 }}
                        />
                        <span>{option.name}</span>
                      </MenuItem>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Preferred Location"
                        variant="standard"
                        name="prefer_location"
                        sx={fieldStyle}
                      />
                    )}
                    sx={{ backgroundColor: "#fff", width: "100%" }}
                  />
                  {formik.touched.prefer_location &&
                    formik.errors.prefer_location && (
                      <div className={styles.error}>
                        {formik.errors.prefer_location}
                      </div>
                    )}
                </Grid>
              )}
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      formik.touched.rate && formik.errors.rate ? "45%" : "62%",
                  }}
                >
                  <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="rate"
                  label="Hourly Rate"
                  variant="standard"
                  name="rate"
                  onChange={handleRateChange}
                  onBlur={formik.handleBlur}
                  value={formatRateDisplay(formik.values.rate)}
                  sx={fieldStyle}
                />
                {formik.touched.rate && formik.errors.rate && (
                  <div className={styles.error}>{formik.errors.rate}</div>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{ padding: "5px 10px 10px 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      formik.touched.primary_skills &&
                      formik.errors.primary_skills
                        ? "40%"
                        : "60%",
                  }}
                >
                  <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
                </Box>
                <Autocomplete
                  multiple
                  id="primary-skills-autocomplete"
                  options={skillData}
                  disableCloseOnSelect
                  value={skillData.filter((skill) =>
                    formik.values.primary_skills.includes(skill.id)
                  )}
                  onChange={(event, value) => {
                    const selectedValues = value.map((skill) => skill.id);
                    formik.setFieldValue("primary_skills", selectedValues);
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option.name}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option.name}</span>
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Primary Skills"
                      variant="standard"
                      name="primary_skills"
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
                {formik.touched.primary_skills &&
                  formik.errors.primary_skills && (
                    <div className={styles.error}>
                      {formik.errors.primary_skills}
                    </div>
                  )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{ padding: "5px 10px 10px 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  style={{
                    top:
                      formik.touched.secondary_skills &&
                      formik.errors.secondary_skills
                        ? "40%"
                        : "60%",
                  }}
                >
                  <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
                </Box>
                <Autocomplete
                  multiple
                  id="secondary-skills-autocomplete"
                  options={skillData}
                  disableCloseOnSelect
                  value={skillData.filter((skill) =>
                    formik.values.secondary_skills.includes(skill.id)
                  )}
                  onChange={(event, value) => {
                    const selectedValues = value.map((skill) => skill.id);
                    formik.setFieldValue("secondary_skills", selectedValues);
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option.name}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option.name}</span>
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Secondary Skills"
                      variant="standard"
                      name="secondary_skills"
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
              </Grid>
            </Grid>
            <Box className={styles.add_consultant_btns}>
              <button type="submit" disabled={formik.isSubmitting}>
                {formik.isSubmitting
                  ? isEdit
                    ? "Updating..."
                    : "Adding..."
                  : isEdit
                  ? "Update"
                  : "Add to Hotlist"}
              </button>
            </Box>
          </form>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CreateHotListDraw;
